import { exportTestInstance, recordTestInstance } from '../axios';

const get = (customerId: any, locationId: any, tireOptixSurveyId: any, glsSurveyId: any, viewErrors: any, sortOrder:any, pagination: any = { searchString: null }) =>
  recordTestInstance.post('/tire-optix-tire-details', { customerId, locationId, tireOptixSurveyId, glsSurveyId, viewErrors, pagination, sortOrder });

const submit = (comments: any, customerId: any, locationId: any, tires: any, pagination: any = { searchString: null }) =>
  recordTestInstance.post('/tire-optix-tire-details/submit', { comments, customerId, locationId, tires, pagination });

const markAsNoMatch = (customerId: any, locationId: any, tires: any, glsSurveyId: any, pagination: any = { searchString: null }) =>
  recordTestInstance.post('/tire-optix-tire-details/mark-no-match', { customerId, locationId, tires, glsSurveyId, pagination });

const error = (payload: any) => recordTestInstance.post('/tire-optix-tire-details/error', payload);

const printExcel = (input: any) =>
  exportTestInstance.post('/tire-optix-tire-details/export-excel', { input }, {
    headers:
    {
      'Content-Disposition': 'attachment; filename=template.xlsx',
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  });

const printPdf = (input: any) =>
  exportTestInstance.post('/tire-optix-tire-details/export-pdf', { input }, {
    headers:
    {
      'Content-Disposition': 'attachment; filename=template.pdf',
      'Content-Type': 'application/pdf',
    },
    responseType: 'arraybuffer',
  });

const transfer = (transferTiresData: any, glsSurveyId: any, tires:any, comments:any, relocateTires: any, transferToCustomer:any, transferByBrand:any ) =>
  recordTestInstance.post('/tire-optix-tire-details/transfer', {transferTiresData, glsSurveyId, tires, comments, relocateTires, transferToCustomer, transferByBrand});

export default {
  get,
  submit,
  markAsNoMatch,
  error,
  printExcel,
  printPdf,
  transfer,
};